import dataManagement from './data-management'
import explorer from './explorer'
// import download from './download'
import task from './task'
// ==============================|| MENU ITEMS ||============================== //
const menuItems = {
  items: [dataManagement, explorer, task]
}

export default menuItems
